export {
  QUERY as GetChannelQuery,
  default as useGetChannel,
} from "./GetChannel";
